import React from 'react'
import { match } from 'ts-pattern'
import UserPathStep, { UserPathStepProps } from '../../ConversionPaths/UserPathStep'
import LeadEventStep from './LeadEventStep'
import SiteVisitStep from '../../ConversionPaths/SiteVisitStep'

type LeadPathStep = {
  Type: 'impression' | 'click' | 'lead' | 'site_visit'
} & UserPathStepProps

export default function LeadPathStep({ path }: { path: LeadPathStep }): JSX.Element {
  return match(path.Type)
    .with('impression', () => <UserPathStep path={path} />)
    .with('click', () => <UserPathStep path={path} />)
    .with('lead', () => <LeadEventStep path={path} />)
    .with('site_visit', () => <SiteVisitStep path={path} />)
    .exhaustive()
}
